<!--
// app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchStatsContainer.vue
-->
<script setup lang="ts">
import type { Match } from "~/src/match/domain/models/Match";
import type { Parameter } from "~/src/stats/domain/models/Parameter";
import type { Player } from "~/src/player/domain/Player";
import type { SeasonStatsPartner } from "~/src/season-cluster/domain/models/01.Season";
import MatchStatsComparison from "~/app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchStatsComparison.vue";
import matchUiService from "~/src/match/infrastructure/ui-services/matchUiService";
import parametersUiService from "~/src/stats/infrastructure/ui-services/parametersUiService";

type Props = {
  match: Match;
};

const { getParameters } = parametersUiService();
const { transformStatus } = matchUiService();
const props = defineProps<Props>();
const parameters = ref<Parameter[]>();
const {
  participants: { homeTeam, awayTeam },
} = props.match;
const allPlayers: Player[] = !!homeTeam && !!awayTeam ? [...homeTeam.players, ...awayTeam.players] : [];
const seasonMvpPartner = ref<SeasonStatsPartner>();

parameters.value = await getParameters();
</script>

<template>
  <!--  MATCH STATS COMPARISON-->

  <div class="py-24 lg:px-6 flex lg:gap-2.5 justify-center flex-wrap lg:flex-nowrap relative">
    <p class="w-full lg:hidden py-2 mx-5 border-gray-700 border-b mb-9 kql-page-section-title">
      {{ $t("match.stats.container.title") }}
    </p>

    <match-stats-comparison
      v-if="
        match &&
        match.participants?.awayTeam &&
        match.participants?.homeTeam &&
        match.stats?.awayTeam &&
        match.stats?.homeTeam
      "
      :seasonId="match.seasonId"
      :season-cluster-id="match.season.seasonClusterId"
      :parameters="parameters || []"
      :match-events="match.events"
      :match-status="
        match.status && transformStatus(match.status) ? transformStatus(match?.status) : undefined
      "
      :players="allPlayers"
      :mvp-partner="seasonMvpPartner"
      :away-team-info="match.participants.awayTeam"
      :home-team-info="match.participants.homeTeam"
      :away-team-total-score="match.scores.awayScore"
      :home-team-total-score="match.scores.homeScore"
      :away-team-stats-data="match.stats?.awayTeam"
      :home-team-stats-data="match.stats?.homeTeam"
    />
  </div>
</template>

<style scoped></style>
